import * as actionTypes from "./actionTypes.ts";
import type { FeedViewPayload } from "../../types/feed.ts";
import type { FeedItemOrderEntry } from "./reducer.ts";

export const setFeedView = (payload: FeedViewPayload & { itemOrder?: FeedItemOrderEntry[] }) => ({
  type: actionTypes.SET_FEED_VIEW,
  payload,
});

export const setFeedItemOrder = (itemOrder: FeedItemOrderEntry[]) => ({
  type: actionTypes.SET_FEED_ITEM_ORDER,
  payload: itemOrder,
});

